// import axiosHelper from "axiosHelper";
import axiosHelper from "../../../../axiosHelper";
import {
  APIUSEROLD,
  API_FAILURE,
  GET_AWAITING_FOR_APPROVAL_LIST,
  GET_NEW_REQUEST_HISTORY_EXPORT,
  GET_PENDING_APPROVAL_LIST,
  GET_VENDOR_NEED_LIST,
} from "../../../../config/constants";
import { apiErrors } from "../../../../helper";
export function fetchVendorNeedList(filter) {
  return (dispatch) => {
    const request = axiosHelper.get(`${APIUSEROLD.getVendorNeedList}`, {
      params: {
        employeeId: filter?.EmployeeId,
        page: filter.current_page,
        vendorCode:filter?.VendorCode,
        applicationNo: filter?.ApplicationNo,
        supplierCategory: filter?.CategoryName,
        requestStatus: filter?.Status,
        plant: filter?.PlantName,
        supplierName: filter?.SupplierName,
        pageSize: filter.per_page,
        SearchText: filter?.sortField?.supplierName,
        requestedBy: filter?.RequestedBy,
        SortBy: filter?.sortField,
        SortOrder: filter.sortOrder,
        RequestFromDate: filter.requestFromDate == null ? filter.newDate : filter.requestFromDate,
        RequestToDate: filter.requestToDate == null ? filter.newDate : filter.requestToDate,
      }, // Assuming filter contains necessary query parameters
    });

    return request
      .then((response) => {
        if (response?.data || response.status === 204) {
          dispatch({
            type: GET_VENDOR_NEED_LIST,
            payload: {
              data: response.status === 204 ? [] : response?.data?.Result,
              filter, // Include filter in payload
            },
          });
          return response;
        }
      })
      .catch((error) => {
        dispatch({ type: API_FAILURE });
        throw error;
      });
  };
}

// export function fetchPendingForApproval(filter, callback) {

//   return (dispatch) => {
//     const request = axiosHelper.get(`${APIUSEROLD.getPendingforApprovalList}`, {
//       params: {
//         EmployeeId: filter?.EmployeeId,
//         page: filter.current_page,
//         pageSize: filter.per_page,
//         supplierName: filter?.SupplierName,
//         SortBy: filter?.sortField,
//         applicationNo: filter?.VendorRequirementRegistrationApplicationNo,
//         category: filter?.SupplierCategory,
//         requestedBy: filter?.RequestedBy,
//         plant: filter?.PlantName,
//         requestedOn: filter?.RequestedOn,
//         SortOrder: filter.sortOrder,
//         RequestFromDate: filter.requestFromDate == null ? filter.newDate : filter.requestFromDate,
//         RequestToDate: filter.requestToDate == null ? filter.newDate : filter.requestToDate,
//       }, // Assuming filter contains necessary query parameters
//     });
//     request
//       .then((response) => {
//         if (response?.data || response.status === 204) {
//           dispatch({
//             type: GET_PENDING_APPROVAL_LIST,
//             payload: {
//               data: response.status === 204 ? [] : response?.data?.Result,

//               filter, // Include filter in payload
//             },
//           });
//           callback(response, null);
//         }
//       })
//       .catch((error) => {
//         dispatch({ type: API_FAILURE });
//         callback(null, error);
//         // apiErrors(error);
//       });
//   };
// }
export function fetchPendingForApproval(filter) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      const request = axiosHelper.get(`${filter?.isDelegated ? APIUSEROLD.getPendingforApprovalDelegatedList : APIUSEROLD.getPendingforApprovalList}`, {
        params: {
          EmployeeId: filter?.EmployeeId,
          page: filter.current_page,
          pageSize: filter.per_page,
          supplierName: filter?.SupplierName,
          SortBy: filter?.sortField,
          applicationNo: filter?.VendorRequirementRegistrationApplicationNo,
          category: filter?.SupplierCategory,
          requestedBy: filter?.RequestedBy,
          isDelegated:filter?.isDelegated,
          plant: filter?.PlantName,
          requestedOn: filter?.RequestedOn,
          SortOrder: filter.sortOrder,
          RequestFromDate: filter.requestFromDate == null ? filter.newDate : filter.requestFromDate,
          RequestToDate: filter.requestToDate == null ? filter.newDate : filter.requestToDate,
        },
      });

      request
        .then((response) => {
          if (response?.data || response.status === 204) {
            dispatch({
              type: GET_PENDING_APPROVAL_LIST,
              payload: {
                data: response.status === 204 ? [] : response?.data?.Result,
                filter,
              },
            });
            resolve(response);
          } else {
            reject(new Error('No data found'));
          }
        })
        .catch((error) => {
          dispatch({ type: API_FAILURE });
          if (error.response.status === 401) {
            apiErrors(error)
          }else{

            reject(error);
          }
        });
    });
  };
}

export function fetchPendingForApprovalExport(filter, callback) {

  return (dispatch) => {
    const request = axiosHelper.get(
      `${APIUSEROLD.getPendingForApprovalExport}`,
      {
        params: {
          EmployeeId: filter?.EmployeeId,
          supplierName: filter?.SupplierName,
          SortBy: filter?.sortField,
          applicationNo: filter?.VendorRequirementRegistrationApplicationNo,
          category: filter?.SupplierCategory,
          requestedBy: filter?.RequestedBy,
          plant: filter?.PlantName,
          requestedOn: filter?.RequestedOn,
          SortOrder: filter.sortOrder,
          RequestFromDate: filter.requestFromDate == null ? filter.newDate : filter.requestFromDate,
          RequestToDate: filter.requestToDate == null ? filter.newDate : filter.requestToDate,
          // RequestToDate: filter.requestToDate ||filter?.requestFromDate,
        }, // Assuming filter contains necessary query parameters
      }
    );
    request
      .then((response) => {
        if (response?.data || response.status === 204) {
          dispatch({
            type: GET_NEW_REQUEST_HISTORY_EXPORT,
            payload: {
              data: response.status === 204 ? [] : response?.data,

              filter, // Include filter in payload
            },
          });
          callback(response, null);
        }
      })
      .catch((error) => {
        dispatch({ type: API_FAILURE });
        if (error.response.status === 401) {
          apiErrors(error)
        }
        // callback(null, error);
        // apiErrors(error);
      });
  };
}


export function fetchWaitingForApprovalExport(filter, callback) {

  return (dispatch) => {
    const request = axiosHelper.get(
      `${APIUSEROLD.getAwaitingForApprovalExport}`,
      {
        params: {
          EmployeeId: filter?.EmployeeId,
          supplierName: filter?.SupplierName,
          SortBy: filter?.sortField,
          applicationNo: filter?.VendorRequirementRegistrationApplicationNo,
          category: filter?.SupplierCategory,
          requestedBy: filter?.RequestedBy,
          plant: filter?.PlantName,
          requestedOn: filter?.RequestedOn,
          SortOrder: filter.sortOrder,
          RequestFromDate: filter.requestFromDate == null ? filter.newDate : filter.requestFromDate,
          RequestToDate: filter.requestToDate == null ? filter.newDate : filter.requestToDate,
          // RequestToDate: filter.requestToDate ||filter?.requestFromDate,
        }, // Assuming filter contains necessary query parameters
      }
    );
    request
      .then((response) => {
        if (response?.data || response.status === 204) {
          dispatch({
            type: GET_NEW_REQUEST_HISTORY_EXPORT,
            payload: {
              data: response.status === 204 ? [] : response?.data,

              filter, // Include filter in payload
            },
          });
          callback(response, null);
        }
      })
      .catch((error) => {
        dispatch({ type: API_FAILURE });
        // callback(null, error);
        if (error.response.status === 401) {
          apiErrors(error)
        }
      });
  };
}
// export function fetchingAwaitingApprovals(filter, callback) {
//   return (dispatch) => {
//     const request = axiosHelper.get(`${APIUSEROLD.getAwaitingForApprovals}`, {
//       params: {
//         EmployeeId: filter?.EmployeeId,
//         page: filter.current_page,
//         pageSize: filter.per_page,
//         SearchText: filter?.sortField?.supplierName,
//         SortBy: filter?.sortField,
//         SortOrder: filter.sortOrder,
//         RequestFromDate: filter.requestFromDate,
//         RequestToDate: filter.requestFromDate,
//       }, // Assuming filter contains necessary query parameters
//     });
//     request
//       .then((response) => {
//         if (response?.data || response.status === 204) {
//           dispatch({
//             type: GET_AWAITING_FOR_APPROVAL_LIST,
//             payload: {
//               data: response.status === 204 ? [] : response?.data?.Result,

//               filter, // Include filter in payload
//             },
//           });
//           callback(response, null);
//         }
//       })
//       .catch((error) => {
//         dispatch({ type: API_FAILURE });
//         callback(null, error);
//         // apiErrors(error);
//       });
//   };
// }
export function fetchingAwaitingApprovals(filter) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      const request = axiosHelper.get(`${APIUSEROLD.getAwaitingForApprovals}`, {
        params: {
          EmployeeId: filter?.EmployeeId,
          page: filter.current_page,
          pageSize: filter.per_page,
          supplierName: filter?.SupplierName,
          SortBy: filter?.sortField,
          applicationNo: filter?.VendorRequirementRegistrationApplicationNo,
          category: filter?.SupplierCategory,
          requestedBy: filter?.RequestedBy,
          plant: filter?.PlantName,
          requestedOn: filter?.RequestedOn,
          SortOrder: filter.sortOrder,
          RequestFromDate: filter.requestFromDate == null ? filter.newDate : filter.requestFromDate,
          RequestToDate: filter.requestToDate == null ? filter.newDate : filter.requestToDate,
        },
      });

      request
        .then((response) => {
          if (response?.data || response.status === 204) {
            dispatch({
              type: GET_AWAITING_FOR_APPROVAL_LIST,
              payload: {
                data: response.status === 204 ? [] : response?.data?.Result,
                filter,
              },
            });
            resolve(response);
          } else {
            reject(new Error('No data found'));
          }
        })
        .catch((error) => {
          dispatch({ type: API_FAILURE });
          if (error.response.status === 401) {
            apiErrors(error)
          }else{
            reject(error);
          }
         
        });
    });
  };
}

export function getVendorListFormDetailById(id) {
  const request = axiosHelper.get(
    `${APIUSEROLD.getVendorListFormDetailById}=${id}`
  ); // Include the id in the URL
  return request
    .then((response) => {
      if (response.data.Result) {
        // You can perform additional actions if needed
      }
      return response?.data; // Return the response to the caller
    })
    .catch((error) => {
      if (error.response.status === 401) {
        apiErrors(error)
      }else{
        throw error; // Re-throw the error to the caller
      }
      // throw error; // Re-throw the error to the caller
    });
}

export async function excelDownload(params) {
  try {
    const response = await axiosHelper.post(
      `${APIUSEROLD.importExcelVendorNeedFormList}`,
      {
        EmployeeId: params.EmployeeId,
        PlantCode: params?.PlantCode,
        CategoryCode: params?.CategoryCode,
        Status: params?.Status,
        RequestFromDate: params?.fromDate || null,
        RequestToDate: params?.toDate || null,
        searchText: params?.searchText,
      }
    );

    const fileUrl = response.data.Data[0];

    const link = document.createElement("a");
    link.href = fileUrl;
    link.setAttribute("download", "");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (error) {
    if (error.response.status === 401) {
      apiErrors(error)
    }else{
      throw error;
    }
   
  }
}
